export default __webpack_public_path__ + "static/media/mysql.4af45e7a.svg";